import { render, staticRenderFns } from "./xskTreeTransfer.vue?vue&type=template&id=7636b34c&scoped=true"
import script from "./xskTreeTransfer.vue?vue&type=script&lang=js"
export * from "./xskTreeTransfer.vue?vue&type=script&lang=js"
import style0 from "./xskTreeTransfer.vue?vue&type=style&index=0&id=7636b34c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7636b34c",
  null
  
)

export default component.exports